// @ts-nocheck
import * as _ from 'lodash';
import { Column } from 'slickgrid';
import { Formatter } from 'slickgrid';

const ATTRS_TO_COPY = [
  'getCellValue',
  'skipFilter',
  'filterRawData',
  'filterFormattedData',
  'skipExport',
  'exportRawData',
  'exportDataFormatter',
];

export function columnFormatterCache(
  originalFormatter: Formatter<any>,
  column: Partial<Column<any>>,
) {
  if (column.noFormatterCache) {
    return originalFormatter;
  }

  if (_.isFunction(originalFormatter)) {
    function formatterCache(
      row: number,
      cell: number,
      value: any,
      columnDef: Column<T>,
      dataContext: T,
      grid: SlickGrid,
    ) {
      const path = `$$_cache.${column.id}`;

      if (!_.hasIn(dataContext, path)) {
        const result = originalFormatter(
          row,
          cell,
          value,
          columnDef,
          dataContext,
          grid,
        );
        _.set(dataContext, path, result);
        return result;
      }

      return _.get(dataContext, path, '');
    }

    Object.defineProperty(formatterCache, 'name', {
      value: `${column.formatter.name}_cache`,
      writable: false,
    });

    for (const attr of ATTRS_TO_COPY) {
      if (_.has(originalFormatter, attr)) {
        Object.defineProperty(formatterCache, attr, {
          value: _.get(originalFormatter, attr),
          writable: false,
        });
      }
    }
    return formatterCache;
  }

  return originalFormatter;
}
